<template>
  <div class="canvas-scroll">
    <v-layout row align-center ml-4 wrap v-if="tabCount > 1">
      <v-flex md4 lg3  class="selectRoomDropdown">
        <div>
          <v-select
            v-model="selection"
            :items="tabArray"
            label="Select Side"
            outline
          ></v-select>
        </div>
      </v-flex>
      <v-flex md4 lg6>
        <div class="live-container" style="margin: 0 auto;">
          <div class="live-data">{{ $t("LIVE") }}</div>
          <v-progress-linear
            style="width: 50px"
            :indeterminate="true"
            height="3"
            color="accent"
          ></v-progress-linear>
        </div>
      </v-flex>
    </v-layout>
    <v-container
      fluid
      grid-list-md
      pa-0
      class="live-bg"
      v-else
    >
      <v-layout row align-center justify-center wrap>
        <v-spacer />
        <v-flex xs1>
          <div class="live-container">
            <div class="live-data">{{ $t("LIVE") }}</div>
            <v-progress-linear
              :indeterminate="true"
              height="3"
              color="accent"
            ></v-progress-linear>
          </div>
        </v-flex>
        <v-spacer />
      </v-layout>
    </v-container>
    <div id="drawCanvas"></div>
    <div class="legend">
      <div class="legend-title">Comm. Status</div>
      <div><span class="circle-green"></span> Successful</div>
      <div><span class="circle-red"></span> Failed</div>
      <div><span class="circle-grey"></span> No Status</div>
      <v-divider class="space-horizontal"></v-divider>
      <div v-show="Object.keys(lineAttrLegend).length > 0" class="legend-title">Cable Type</div>
      <div v-for="(attr, key) in lineAttrLegend" :key="key"><span :style="{ display: 'inline-block', width: '15px', height: '10px', background: `${attr}` }"></span> {{ key }}</div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGettersMixin } from "@/util/mixin/index";
import { mapGetters, mapMutations } from "vuex";
import {
  WriteTextAndStatus
} from '@/components/sld/js/DrawTable';
import CommunicationDiagram from "@/services/CommunicationDiagram";
import commLineAttr from "@/components/communicationDiagram/json/pathAttr";
import commRectAttr from "@/components/communicationDiagram/json/rectAttr";
import commTextAttr from "@/components/communicationDiagram/json/textAttr";
import SvgPaper from "@/components/sld/js/SvgPaper";

const moment = require("moment");
const toArray = (value) => Array.isArray(value) ? value : value ? [value] : [];

export default {
  mixins: [mapGettersMixin],
  data() {
    return {
      paper: null,
      tabCount: null,
      selection: "",
      imageMap: {},
      sldSym: {},
      legend: false,
      svgImage: {},
      isEtilogPresent: false,
      loggerNodeList: [],
      lineAttrLegend: {}
    };
  },
  computed: {
    ...mapGetters(["getSelectedPlantId"]),
    tabSelection() {
      return this.sldSym[this.selection] || {};
    },
    tabArray() {
      return this.sldSym.tabs || [];
    },
    computedSvgImage() {
      const baseUrl = process.env.VUE_APP_BASE_URL || ("http://" + location.hostname + ":3030");
      let svgObj = {};
      
      Object.keys(this.svgImage).forEach((key) => {
        let logo = this.svgImage[key];

        const encodedUrl = encodeURIComponent(logo);
        svgObj[key] = `${baseUrl}/api/v2/assets?url=${encodedUrl}`
      });
      
      return svgObj;
    },
  },
  async mounted() {
    try {
      this.SET_PROGRESS_BAR(true);
      // Communication diagram Images
      this.svgImage = await CommunicationDiagram.getSVGimage('communicationDiagram');
      // Get JSON file for Communication diagram
      this.sldSym = await CommunicationDiagram.getSymbol(
        this.getSelectedPlantId
      );
      this.SET_PROGRESS_BAR(false);
      this.selection = this.sldSym.tabs[0];
      this.tabCount = this.sldSym.tabs.length;
    } catch (err) {
      this.SET_PROGRESS_BAR(false);
    }
    if (this.selection) {
      this.drawSld();
    }
  },
  destroyed() {
    if (this.paper) {
      this.paper.remove();
    }
    if (this.isEtilogPresent) {
      this.$mqtt.unsubscribe(`onlineusers`)
    }
  },
  methods: {
    ...mapMutations(["SET_LAST_CALL_TIME", "SET_PROGRESS_BAR"]),
    side(value) {
      this.selection = value;
    },
    callAllApi() {
      let updateTime = moment().format("MM-DD-YYYY H:mm:ss");
      this.SET_LAST_CALL_TIME(updateTime);

      toArray(this.tabSelection.devices).forEach((D) => {
        this.loadData(D);
      });
    },
    loadData: async function (device) {
      // Data
      if (device != 'logger') {
        const response = await CommunicationDiagram.getDataV2(
          this.getSelectedPlantId,
          device
        );
  
        const table = this.tabSelection.table[device]
        if (!table) return
  
        const tHeight = 20
  
        const groupedData = _.groupBy(response.data.message, (item) => item.id)
        Object.keys(table.data).forEach(key => {
          let {
            x,
            y,
            width
          } = table.data[key]

          if (groupedData && groupedData[key] && groupedData[key][0]) {
            WriteTextAndStatus(
              groupedData[key][0].ignore_status == 0 ? '#3CB371' : '#FF5252',
              x,
              y,
              width,
              tHeight,
              this.paper,
              table.data[key] && table.data[key].name != '' ? table.data[key].name : '',
              this.isDark
            )
          } else {
            WriteTextAndStatus(
              '#9E9E9E',
              x,
              y,
              width,
              tHeight,
              this.paper,
              table.data[key] && table.data[key].name != '' ? table.data[key].name : '',
              this.isDark
            )
          }
        })
      } else {
        this.isEtilogPresent = true
      }
    },
    drawImage() {
      toArray(this.tabSelection.image).forEach((symbolItems) => {
        let items = null;
        const { uId, device } = symbolItems;
        if (symbolItems.device === "inverter") {
          items = this.paper.image(
            this.computedSvgImage[symbolItems.id],
            symbolItems.x,
            symbolItems.y,
            symbolItems.width,
            symbolItems.height
          );
          if (uId !== undefined) {
            if (!this.imageMap[device]) {
              this.imageMap[device] = {};
            }
            this.imageMap[device][uId] = {
              obj: items,
              id: symbolItems.id,
            };
          }
        } else {
          items = this.paper.image(
            this.computedSvgImage[symbolItems.id],
            symbolItems.x,
            symbolItems.y,
            symbolItems.width,
            symbolItems.height
          );
        }
        if (symbolItems.location) {
          items.click(() => {
            this.$router.push(symbolItems.location);
          });
        }
      });
    },
    drawReact() {
      let sldRect = this.tabSelection.rect ? this.tabSelection.rect : [];
      sldRect.forEach((items) => {
        let rect = this.paper.rect(items.x, items.y, items.width, items.height);
        if (!this.isDark && commRectAttr[`${items.attr}Light`]) {
          rect.attr(commRectAttr[`${items.attr}Light`]);
        } else {
          rect.attr(commRectAttr[items.attr]);
        }
        rect.node.id = rect.id;
      });
    },
    drawText() {
      let sldText = this.tabSelection.text ? this.tabSelection.text : [];
      sldText.forEach((textItems) => {
        let text = this.paper.text(textItems.x, textItems.y, textItems.name);
        if (!this.isDark && commTextAttr[`${textItems.attr}Light`]) {
          text.attr(commTextAttr[`${textItems.attr}Light`]);
        } else {
          text.attr(commTextAttr[textItems.attr]);
        }
      });
    },
    drawPath() {
      let sldPath = this.tabSelection.path ? this.tabSelection.path : [];
      sldPath.forEach((pathItems) => {
        let path = this.paper.path(pathItems.image);
        if (!this.isDark && commLineAttr[`${pathItems.attr}Light`]) {
          path.attr(commLineAttr[`${pathItems.attr}Light`]);
          if (!this.lineAttrLegend[`${pathItems.attr}Light`]) {
            this.lineAttrLegend[`${pathItems.attr}Light`] = commLineAttr[`${pathItems.attr}Light`].stroke
          }
        } else {
          path.attr(commLineAttr[pathItems.attr]);
          if (!this.lineAttrLegend[pathItems.attr]) {
            this.lineAttrLegend[pathItems.attr] = commLineAttr[pathItems.attr].stroke
          }
        }
        path.node.id = pathItems.id;
      });
    },
    async drawSld() {
      if (!this.tabSelection.paper) return;

      this.paper = new SvgPaper(
        "drawCanvas",
        this.tabSelection.paper.width,
        this.tabSelection.paper.height
      );
      this.drawImage();
      this.drawReact();
      this.drawText();
      this.drawPath();
      this.setIntervalWithoutDelay(() => {
        this.callAllApi();
      }, 60000);

      // FOR ETI-LOG status
      if (this.isEtilogPresent) {
        const response = await CommunicationDiagram.getEpicStatus(
          this.getSelectedPlantId
        );
        const groupedData = _.groupBy(response.data.message, (item) => item.rpi_id)
  
        const table = this.tabSelection.table['logger']
        if (!table) return
  
        const tHeight = 20
  
        Object.keys(table.data).forEach(key => {
          let {
            x,
            y,
            width
          } = table.data[key]

          let tableCell = WriteTextAndStatus(
            groupedData[key][0].state == 0 ? '#FF5252' : '#3CB371',
            x,
            y,
            width,
            tHeight,
            this.paper,
            table.data[key] && table.data[key].name != '' ? table.data[key].name : '',
            this.isDark
          )
          this.loggerNodeList.push(...tableCell)
        })

        this.mqttHandler()
      }
    },
    mqttHandler() {
      this.$mqtt.subscribe(`onlineusers`)
      this.$mqtt.on('message', (topic, message) => {
        if (topic == 'onlineusers') {
          const mqttData = JSON.parse(message)
          const table = this.tabSelection.table['logger']
          if (!table) return

          this.loggerNodeList.forEach(element => {
            element.remove()
          })
          this.loggerNodeList = []
          Object.keys(table.data).forEach(key => {
            let {
              x,
              y,
              width
            } = table.data[key]

            let tableCell = WriteTextAndStatus(
              mqttData[key] != undefined ? '#3CB371' : '#FF5252',
              x,
              y,
              width,
              20,
              this.paper,
              table.data[key] && table.data[key].name != '' ? table.data[key].name : '',
              this.isDark
            )
            this.loggerNodeList.push(...tableCell)
          })
        }
      })
      this.$mqtt.on('error', function(error) {
        console.log('ERROR: ', error)
      })

      this.$mqtt.on('offline', function() {
        console.log('offline')
      })

      this.$mqtt.on('reconnect', function() {
        console.log('reconnect')
      })
    },
  },
  watch: {
    selection(newVal, oldVal) {
      if (oldVal != "") {
        if (this.paper) {
          this.paper.remove();
        }
        this.drawSld();
      }
    },
    theme() {
      if (this.paper) {
        this.paper.remove();
      }
      this.drawSld();
    },
    async getSelectedPlantId() {
      try {
        this.sldSym = await CommunicationDiagram.getSymbol(this.getSelectedPlantId);
        this.selection = this.sldSym.tabs[0];
        this.lineAttrLegend = {}
        this.tabCount = this.sldSym.tabs.length;
        if (this.paper) {
          this.paper.remove();
        }
        this.drawSld();
      } catch (err) {
        if (this.paper) {
          this.paper.remove();
        }
      }
    },
  },
};
</script>

<style>
#drawCanvas {
  width: 1500px;
  overflow-x: visible;
  position: relative;
  top: 75px;
  transform: scale(1.1, 1.1);
}

.v-progress-linear {
  margin: 0;
}

.live-data {
  font-weight: bold;
  font-family: "Poppins", sans-serif;
  letter-spacing: 0.1em;
  text-align: center;
  color: var(--v-primaryText-base);
  padding-top: 10px;
  animation: flipAni 4s 0s linear infinite;
}

.col {
  width: 300px;
  text-align: center;
  padding: 6px;
  border: 1px solid #34495e;
}

.canvas-scroll {
  overflow-x: auto;
  overflow-y: hidden;
}

.live-container {
  width: 50px;
}

.legend {
  position: absolute;
  top: 80px;
  right: 15px;
  width: 140px;
  overflow-x: auto;
  color: var(--v-primaryText-base);
  border: 1px solid var(--v-primaryText-base);
  padding: 10px;
}

.circle-green {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #3CB371;
  border-radius: 50%;
}

.circle-red {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #FF5252;
  border-radius: 50%;
}

.circle-grey {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #9E9E9E;
  border-radius: 50%;
}

.legend-title {
  font-size: 16px;
  font-weight: 700;
}

.space-horizontal {
  margin-top: 5px;
  padding-bottom: 5px;
}

@media only screen and (max-width: 576px) {
  #drawCanvas {
    background-color: #1c2137;
    overflow-x: auto;
    position: absolute;
  }
}

@keyframes flipAni {
  0% {
    transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -o-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
  }

  50% {
    transform: scale(-1, 1);
    -webkit-transform: scale(-1, 1);
    -moz-transform: scale(-1, 1);
    -o-transform: scale(-1, 1);
    -ms-transform: scale(-1, 1);
  }

  100% {
    transform: scale(1, 1);
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -o-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
  }
}
</style>
